import type { AxiosAsyncStatus } from '@/@bothrs-react/hooks/useAxiosAsync'
import type { Appointment } from '@/modules/appointment/types/appointment.types'
import type { Encounter } from '@/modules/encounter/types/encounter.types'

enum TimelineErrorState {
  /**
   * Error when the user is not found. (404)
   */
  NOT_FOUND = 'NOT_FOUND',
  /**
   * Error when the user is not authorized. (401)
   */
  INTRAMUROS_TOKEN_EXPIRED = 'INTRAMUROS_TOKEN_EXPIRED',
  /**
   * Generic error. (any other error)
   */
  GENERIC = 'GENERIC',
}

/**
 * Context type for all props that is shared in all timeline page.
 */
type TimelineContextType = {
  appointments: {
    value: Appointment[] | undefined
    status: AxiosAsyncStatus
    isLoading: boolean
  }
  encounters: {
    value: Encounter[] | undefined
    status: AxiosAsyncStatus
    isLoading: boolean
  }
  isLoading: boolean
  error?: TimelineErrorState
  hasIntramurosPermission?: boolean
  intramurosName?: string
  forceReload: () => void
}

export type { TimelineContextType }
export { TimelineErrorState }
